import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Autocomplete,
  Box,
  Button,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Tooltip,
  Typography
} from '@mui/material'
import GetAppIcon from '@material-ui/icons/GetApp'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import PropTypes from 'prop-types'
import { useTheme } from '@mui/material/styles'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useEffect, useState } from 'react'
import { KeyboardArrowLeft, KeyboardArrowRight } from '@material-ui/icons'
import LastPageIcon from '@mui/icons-material/LastPage'
import FirstPageIcon from '@mui/icons-material/FirstPage'
import { useDispatch } from 'react-redux'
import { CSVLink } from 'react-csv'
import { getRequest, postRequest } from '../../globalhelper/helper'
import { hideLoader, showLoader } from '../../redux/Common/commonActions'
import moment from 'moment'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'

function TablePaginationActions (props) {
  const theme = useTheme()
  const { count, page, rowsPerPage, onPageChange } = props
  const [previousCount, setPreviousCount] = useState(count)

  useEffect(() => {
    if (count !== previousCount && page !== 0) {
      onPageChange(null, 0)
    }
    setPreviousCount(count)
  }, [count, page, onPageChange, previousCount])

  const handleFirstPageButtonClick = event => {
    onPageChange(event, 0)
  }

  const handleBackButtonClick = event => {
    onPageChange(event, page - 1)
  }

  const handleNextButtonClick = event => {
    onPageChange(event, page + 1)
  }

  const handleLastPageButtonClick = event => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1))
  }

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label='first page'
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label='previous page'
      >
        {theme.direction === 'rtl' ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label='next page'
      >
        {theme.direction === 'rtl' ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label='last page'
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  )
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired
}

function Linking_PO_IP () {
  let [formData, setFormdata] = useState({
    Company: null,
    month: moment().format('MM-YYYY')
  })
  let [dropDown, setDropDown] = useState(null)
  let [Companies, setCompanies] = useState(null)
  let [TableData, setTableData] = useState([])
  let [filtered, setFiltered] = useState([])
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [dirtyRow, setDirtyRow] = useState([])

  let dispatch = useDispatch()

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - TableData.length) : 0

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleChanges = (name, value) => {
    if (name === 'month' && value !== '') {
      var currentDate = moment(value)
      var firstDay = currentDate.startOf('month').format('YYYY-MM-DD')
      var lastDay = currentDate.endOf('month').format('YYYY-MM-DD')
      setFormdata(prev => {
        return { ...prev, fromDate: firstDay, toDate: lastDay, [name]: value }
      })
    }
    setFormdata({ ...formData, [name]: value })
  }

  const handleDataChanges = (sno, value) => {
    if (
      value === '' &&
      !value &&
      dirtyRow?.findIndex(row => row === sno) > -1
    ) {
      let updatedData = dirtyRow.filter(exSno => exSno === sno)
      console.log(updatedData, 'if')
      setDirtyRow(updatedData)
    } else {
      setDirtyRow(prev => {
        return [...prev, sno]
      })
    }

    setTableData(prev =>
      prev.map(data => {
        if (data.sno === sno) {
          return { ...data, 'SPE Ref': value }
        } else return data
      })
    )
    setFiltered(prev =>
      prev.map(data => {
        if (data.sno === sno) return { ...data, 'SPE Ref': value }
        else return data
      })
    )
  }

  const handleSubmit = async () => {
    try {
      dispatch(showLoader())
      let { res } = await getRequest(
        `api/veranda/getPOAndIPData?orgid=${formData.Company.orgid}&PEID=${formData?.PEID?.value}`
      )
      setTableData(JSON.parse(res.data))
      setFiltered(JSON.parse(res.data))
    } catch (error) {
      console.log(error)
    } finally {
      dispatch(hideLoader())
    }
  }

  useEffect(() => {
    getRequest(`api/edureka/getCompanyAssignedToUser`)
      .then(response => {
        console.log(response.res.data)
        const responseData = response.res.data
        const orgname = [...new Set(responseData.map(item => item))]
        setCompanies(responseData)
        if (orgname.length === 1) {
          handleChanges('Company', orgname[0])
        }
      })
      .catch(err => console.log(err))
  }, [])

  const handleUpdateRows = async () => {
    try {
      let updateRows = TableData.filter(
        item => dirtyRow.includes(item.sno) && item
      )
      let response = await postRequest(`api/veranda/UpdatePE`, updateRows)
    } catch (error) {
      console.log(error)
    } finally {
      handleSubmit()
      setDirtyRow([])
    }
  }

  useEffect(() => {
    if (!formData?.Company?.orgid) return // Guard clause to avoid unnecessary requests

    getRequest(`api/veranda/getPEandSPE?orgid=${formData.Company.orgid}`)
      .then(({ res }) => {
        console.log(res)

        const parsedData = JSON.parse(res.data)

        // Generate SPERef array
        const SPERef = parsedData
          .map(item => `${item?.['SPE ID']}[${item?.['SPE Description']}]`)
          .filter(item => item)

        // Generate unique PEID array (avoiding duplicates)
        const PEID = []
        const seen = new Set()

        parsedData.forEach(item => {
          if (!seen.has(item.planningelementid)) {
            seen.add(item.planningelementid)
            PEID.push({
              label: `${item.planningelementname}[${item.planningelementid}]`,
              value: item.planningelementid
            })
          }
        })

        setDropDown(prev => ({
          ...prev,
          'SPE Ref': [...new Set(SPERef)],
          PEID
        }))
      })
      .catch(err => console.log(err))
  }, [formData?.Company])

  return (
    <>
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel1-content'
          id='panel1-header'
        >
          <Typography variant='h6'>Search</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container gap={2}>
            <Grid item xs={1} sm={2} md={3}>
              <Autocomplete
                size='small'
                fullWidth
                value={formData?.Company || null}
                options={Companies || []}
                getOptionLabel={option => option?.orgname || option}
                isOptionEqualToValue={(option, value) =>
                  option?.orgid === value?.orgid
                }
                onChange={(event, newValue) =>
                  handleChanges('Company', newValue)
                }
                renderInput={params => (
                  <TextField
                    {...params}
                    label='Company'
                    variant='outlined'
                    name='Company'
                  />
                )}
              />
            </Grid>
            <Grid item xs={2}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  label='Period'
                  views={['month', 'year']}
                  value={
                    formData?.month
                      ? moment(formData.month, 'MM-YYYY')
                      : moment()
                  }
                  onChange={newValue => {
                    handleChanges('month', moment(newValue).format('MM-YYYY'))
                  }}
                  renderInput={params => (
                    <TextField fullWidth size='small' {...params} />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={1} sm={2} md={3}>
              <Autocomplete
                size='small'
                fullWidth
                value={formData?.PEID || null}
                options={dropDown?.PEID || []}
                getOptionLabel={option => option?.label || option}
                isOptionEqualToValue={(option, value) =>
                  option?.value === value?.value
                }
                onChange={(event, newValue) => handleChanges('PEID', newValue)}
                renderInput={params => (
                  <TextField
                    {...params}
                    label='Planning Element ID'
                    variant='outlined'
                    name='PEID'
                  />
                )}
              />
            </Grid>
            <Grid item xs={3}>
              <Button
                variant='contained'
                color='primary'
                onClick={handleSubmit}
                disabled={
                  !formData?.Company || !formData?.PEID || !formData?.month
                }
              >
                Submit
              </Button>
              &nbsp;&nbsp;
              <Button
                variant='contained'
                color='error'
                onClick={() => {
                  setFormdata({})
                  setTableData([])
                }}
              >
                Reset
              </Button>
              &nbsp;&nbsp;
              <Button
                variant='contained'
                color='warning'
                onClick={handleUpdateRows}
                disabled={dirtyRow.length === 0}
              >
                SaveChanges
              </Button>
              &nbsp;&nbsp;
              {TableData.length > 0 && (
                <Button variant='contained' color='success'>
                  <CSVLink
                    filename='Reports.csv'
                    data={TableData}
                    style={{ color: 'white' }}
                  >
                    <GetAppIcon fontSize='small' />
                  </CSVLink>
                </Button>
              )}
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      {TableData.length > 0 && (
        <TableContainer
          component={Paper}
          sx={{ maxWidth: '100%', width: '100%', overflowX: 'auto' }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {Object.keys(TableData[0]).map((key, index) => (
                  <TableCell
                    sx={
                      key === 'itemdescription'
                        ? {
                            whiteSpace: 'balance',
                            width: 200,
                            minWidth: 200,
                            maxWidth: 200,
                            boxSizing: 'border-box'
                          }
                        : {
                            width: 200,
                            height: 50,
                            boxSizing: 'border-box',
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis'
                          }
                    }
                    key={index}
                  >
                    {key}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {(filtered.length > 0 &&
                (rowsPerPage > 0
                  ? filtered.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                  : filtered
                ).map((item, rowIndex) => (
                  <TableRow key={rowIndex}>
                    {Object.keys(TableData[0]).map((key, index) => (
                      <TableCell
                        sx={
                          key === 'itemdescription' || key === 'VendorName'
                            ? {
                                whiteSpace: 'balance',
                                width: 200,
                                minWidth: 200,
                                maxWidth: 200,
                                boxSizing: 'border-box'
                              }
                            : {
                                width: 200,
                                height: 50,
                                boxSizing: 'border-box',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis'
                              }
                        }
                        key={index}
                      >
                        {key === 'PO Date' ? (
                          moment(item[key]).format('DD-MM-YYYY')
                        ) : key === 'SPE Ref' ? (
                          <Tooltip
                            placement='right'
                            arrow
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  fontSize: 'medium',
                                  whiteSpace: 'nowrap',
                                  width: 'auto', // Adjusts width based on content
                                  maxWidth: 700 // Optional: limits maximum width
                                }
                              }
                            }}
                            title={item[key]}
                          >
                            <Autocomplete
                              size='small'
                              sx={{ width: 250 }}
                              options={dropDown?.[key] || []}
                              value={item[key] || null}
                              onChange={(event, newValue) =>
                                handleDataChanges(item['sno'], newValue)
                              }
                              renderInput={params => (
                                <TextField
                                  {...params}
                                  label={key}
                                  variant='outlined'
                                  name={key}
                                />
                              )}
                            />
                          </Tooltip>
                        ) : (
                          item[key]
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                ))) || (
                <TableRow>
                  <TableCell
                    colSpan={Object.keys(TableData[0])?.length}
                    sx={{ p: 5 }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100%'
                      }}
                    >
                      <Alert severity='error' variant='outlined'>
                        No matching records found. Please adjust your search criteria.
                      </Alert>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={Object.keys(TableData[0]).length} />
                </TableRow>
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  sx={{
                    position: 'sticky',
                    bottom: 0,
                    backgroundColor: 'white',
                    zIndex: 2
                  }}
                  rowsPerPageOptions={[5, 10, 20, { label: 'All', value: -1 }]}
                  colSpan={4}
                  count={filtered.length}
                  rowsPerPage={rowsPerPage}
                  page={Math.min(
                    page,
                    Math.max(0, Math.ceil(filtered.length / rowsPerPage) - 1)
                  )}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      )}
    </>
  )
}

export default Linking_PO_IP
